import { StepType, useTour } from '@reactour/tour';
import Content from 'ui/components/common/Tour/Content';

import { TOUR_SELECTOR } from '..';

const useGetHowToQuickCreateInvoice = () => {
  const { setIsOpen, setSteps, setCurrentStep } = useTour();
  const { TOUR } = TOUR_SELECTOR;

  const quickCreateInvoiceSteps: StepType[] = [
    {
      content:
        'Click on the + Create button at the upper left corner of your screen.',
      selector: `[data-tut="${TOUR.GENERAL_CREATE.CREATE}"]`,
      position: 'bottom',
      disableActions: true,
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(1), 500);
          },
          false,
        );
      },
      styles: {
        arrow: (base) => ({
          ...base,
          visibility: 'hidden',
        }),
      },
    },
    {
      content: 'Click the Create Invoice option.',
      position: 'right',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.GENERAL_CREATE.INVOICE}"]`,
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(2), 500);
          },
          false,
        );
      },
      styles: {
        arrow: (base) => ({
          ...base,
        }),
      },
    },
    {
      content: (props) => (
        <Content
          {...props}
          type="Create Invoice"
          // eslint-disable-next-line max-len
          content="Fill in the invoice details like the contact the invoice will be billed to, items, amount, date issued, date due, and any necessary file attachments."
        />
      ),
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.INVOICE.FORM.FORM}"]`,
      stepInteraction: false,
      position: 'top',
      padding: 22,
      styles: {
        popover: (base) => ({ ...base, maxWidth: 600 }),
      },
    },
    {
      content: 'Click Preview Draft to see how the invoice will show when sent',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.INVOICE.PREVIEW.DRAFT_BUTTON}"]`,
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(4), 200);
          },
          false,
        );
      },
    },
    {
      content: (props) => (
        <Content
          content="This modal shows you a preview of your created invoice."
          {...props}
        />
      ),
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.INVOICE.PREVIEW.DRAFT_MODAL}"]`,
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(5), 200);
          },
          false,
        );
      },
      padding: 22,
    },
    {
      content: 'Click Close',
      selector: `[data-tut="${TOUR.MODAL_CLOSE_BUTTON}"]`,
      position: 'left',
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(6), 200);
          },
          false,
        );
      },
      padding: 22,
    },
    {
      content: 'Click Save & Continue and you are done.',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.INVOICE.FORM.SAVE_BUTTON}"]`,
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setIsOpen(false);
            setTimeout(() => {
              window.location.href = '/';
            }, 300);
          },
          false,
        );
      },
    },
  ];

  const showQuickCreateInvoiceSteps = () => {
    setTimeout(() => {
      setSteps?.(quickCreateInvoiceSteps);
      setIsOpen(true);
    }, 300);
  };

  return showQuickCreateInvoiceSteps;
};

export default useGetHowToQuickCreateInvoice;
